module.exports = __webpack_public_path__ + "img/MU.f81fc223.png";